import { AssetReport } from '../type/AssetReport.type';

/**
 * Get the year from a yearMonth string (format: YYYY-MM)
 */
export const getYearFromYearMonth = (yearMonth: string): string => {
  return yearMonth.split('-')[0];
};

/**
 * Get all reports for a specific year
 */
export const getReportsForYear = (assetReportList: AssetReport[], year: string): AssetReport[] => {
  return assetReportList.filter((report) => getYearFromYearMonth(report.yearMonth) === year);
};

/**
 * Get the first and last month reports for a specific year
 */
export const getFirstAndLastMonthReports = (
  assetReportList: AssetReport[],
  year: string,
): { firstMonthReport: AssetReport | undefined; lastMonthReport: AssetReport | undefined } => {
  const reportsForYear = getReportsForYear(assetReportList, year);
  
  if (reportsForYear.length === 0) {
    return { firstMonthReport: undefined, lastMonthReport: undefined };
  }
  
  // Sort reports by yearMonth in ascending order
  const sortedReports = [...reportsForYear].sort((a, b) => a.yearMonth.localeCompare(b.yearMonth));
  
  return {
    firstMonthReport: sortedReports[0],
    lastMonthReport: sortedReports[sortedReports.length - 1],
  };
};

/**
 * Get the current year from the current asset report
 */
export const getCurrentYear = (currentAssetReport: AssetReport | undefined): string | undefined => {
  if (!currentAssetReport) return undefined;
  return getYearFromYearMonth(currentAssetReport.yearMonth);
};